import priceSuggestionNo from '../resources/no/priceSuggestion.json';
import priceSuggestionSe from '../resources/se/priceSuggestion.json';
import { PriceSuggestionLanguageResources } from '../types/PriceSuggestionResources';

export const priceSuggestionI18nResources: PriceSuggestionLanguageResources = {
  no: { priceSuggestion: priceSuggestionNo },
  se: { priceSuggestion: priceSuggestionSe },
};
